import React from 'react';

import { Box, Typography } from '@mui/material';

import { SuggestedActionType } from '../types';

import { formatCurrency, formatSignedCurrency, formatSignedPercent, getChangeColor } from './toursPricingUtils';

type ToursProposedChangeRow = {
  suggested_action_type: SuggestedActionType;
  original_tour_price: number;
  current_tour_price?: number | null;
  suggested_price_change_percent: number;
  suggested_price_change_amount?: number | null;
  after_price: number;
};

function getNetChangeColor(value: number | null): string {
  if (value == null || value === 0) {
    return 'text.primary';
  }
  return value > 0 ? 'success.main' : 'error.main';
}

function getCurrentLivePrice(row: ToursProposedChangeRow): number | null {
  if (row.current_tour_price != null) {
    return row.current_tour_price;
  }
  return row.original_tour_price;
}

export default function ToursPricingFormatter({ row }: { row: ToursProposedChangeRow }) {
  const changeColor = getChangeColor(row.suggested_action_type);
  const currentLivePrice = getCurrentLivePrice(row);
  const netVsCurrentAmount = currentLivePrice == null ? null : row.after_price - currentLivePrice;
  const netVsCurrentPercent =
    currentLivePrice != null && currentLivePrice !== 0 && netVsCurrentAmount != null
      ? netVsCurrentAmount / currentLivePrice
      : null;

  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Proposed override:
        </Typography>{' '}
        <Typography component="span" variant="body2" color={changeColor} fontWeight="medium">
          {formatSignedPercent(row.suggested_price_change_percent)}
        </Typography>
      </Typography>
      {row.suggested_price_change_amount != null && (
        <Typography variant="body2">
          <Typography component="span" fontWeight="bold" variant="body2">
            Proposed vs base:
          </Typography>{' '}
          <Typography component="span" variant="body2" color={changeColor} fontWeight="medium">
            {formatSignedCurrency(row.suggested_price_change_amount)}
          </Typography>
        </Typography>
      )}
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Proposed live:
        </Typography>{' '}
        {formatCurrency(row.after_price)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Net vs current:
        </Typography>{' '}
        <Typography component="span" variant="body2" color={getNetChangeColor(netVsCurrentAmount)} fontWeight="medium">
          {formatSignedCurrency(netVsCurrentAmount)}
        </Typography>
        {netVsCurrentPercent != null && (
          <Typography
            component="span"
            variant="body2"
            color={getNetChangeColor(netVsCurrentAmount)}
            fontWeight="medium"
          >
            {' '}
            ({formatSignedPercent(netVsCurrentPercent)})
          </Typography>
        )}
      </Typography>
    </Box>
  );
}
